import { useEffect, useState } from 'react'
import { api } from '../api/client.js'

/**
 * Справочник предметов. Он неизменен на время сессии, поэтому запрос делается
 * один раз на всё приложение, а не на каждый монтаж компонента.
 */

let cache = null
let inflight = null
const subscribers = new Set()

function load() {
  if (cache) return Promise.resolve(cache)
  if (inflight) return inflight

  inflight = api
    .catalog()
    .then((data) => {
      cache = {
        ...data,
        itemsById: new Map(data.items.map((item) => [item.id, item])),
      }
      subscribers.forEach((notify) => notify(cache))
      return cache
    })
    .finally(() => {
      inflight = null
    })

  return inflight
}

export function useCatalog() {
  const [catalog, setCatalog] = useState(cache)

  useEffect(() => {
    if (cache) {
      setCatalog(cache)
      return
    }
    subscribers.add(setCatalog)
    load().catch(() => {})
    return () => subscribers.delete(setCatalog)
  }, [])

  return {
    catalog,
    loading: !catalog,
    /** Возвращает предмет каталога по id — или заглушку, если он неизвестен. */
    getItem: (id) =>
      catalog?.itemsById.get(id) ?? {
        id,
        name: id,
        skin: '',
        rarity: 'consumer',
        weaponType: 'rifle',
        image: null,
      },
  }
}
